//import { css } from "@emotion/react"

import clone from "clone";
import { useNavigate } from "react-router-dom";
import type { ImmutableObject } from "@/lib/immutable";
import { useCheckoutFormState } from "../../../hooks/useCheckoutFormState";
import type { Product } from "../../../hooks/useInventoryState";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";
import { Button } from "../../ui/button";

// ListView - Description
export type ProductBrowserListItemDescriptionProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserListItemDescription: React.FC<
	ProductBrowserListItemDescriptionProps
> = (props) => {
	const product = props.product;
	const productDetailsState = useProductDetailsState();
	const translate = useTranslate();
	const checkoutFormState = useCheckoutFormState();
	const warehouseId = checkoutFormState.get().warehouseIdValue;
	const locationId = checkoutFormState.get().locationIdValue;
	const fromDate = checkoutFormState.get().fromDateValue;
	const toDate = checkoutFormState.get().toDateValue;
	const navigate = useNavigate();

	return (
		<div className="field itemdescription">
			<div className="caption">{translate("Description")}</div>
			<Button
				variant="ghost"
				className="value"
				onClick={async () => {
					return Promise.resolve().then(async () => {
						await productDetailsState.setProductAsync(
							clone(product) as Product,
						);
						navigate(
							`/product/${props.product.Id}/warehouseid/${warehouseId}/locationid/${locationId}/fromdate/${fromDate}/todate/${toDate}`,
						);
						//productDetailsState.setShowPopup(true);
					});
				}}
			>
				{product.ItemName}
			</Button>
		</div>
	);
};
